import { Phone, MessageCircle } from "lucide-react";
import { BRAND, waLink, telLink } from "../../lib/brand";

export default function FloatingActions() {
  return (
    <div
      data-testid="floating-actions"
      className="fixed bottom-6 right-5 md:right-8 z-40 flex flex-col gap-3"
    >
      <a
        data-testid="whatsapp-floating-button"
        href={waLink()}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="group relative w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-[0_10px_28px_-8px_rgba(37,211,102,0.55)] hover:scale-110 transition-transform"
      >
        <MessageCircle size={22} />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-ink text-white text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity hidden md:block">
          WhatsApp
        </span>
      </a>
      <a
        data-testid="call-floating-button"
        href={telLink()}
        aria-label={`Call ${BRAND.name}`}
        className="group relative w-14 h-14 rounded-full bg-ink text-white grid place-items-center shadow-[0_10px_28px_-8px_rgba(10,10,10,0.55)] hover:scale-110 hover:bg-ink-soft transition"
      >
        <Phone size={20} />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-ink text-white text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity hidden md:block">
          Call Now
        </span>
      </a>
    </div>
  );
}
